import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { ThemeProvider } from './theme';
import App from './App';
import './index.css';
import './styles/theme.css';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </ThemeProvider>
);
